import { render } from "./like-react-stats.vue?vue&type=template&id=f7809b9e&ts=true"
import script from "./like-react-stats.vue?vue&type=script&lang=ts"
export * from "./like-react-stats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__